export default __webpack_public_path__ + "static/media/main_banner_mobile.cc4f5e6c.jpg";